export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12909.b6258449.jpg";